import { config } from "../../config"
import { Book } from "./data-types"

export const getBookByIsbn13 = async (isbn13: string, token?: string): Promise<Book> => {
  const authHeaders: {[key: string]: string} = {}
  if (token) {
      authHeaders['token'] = token!
  }

  const res = await fetch(`${config.api.urlV1}/book/?isbn13=${isbn13}`, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      ...authHeaders,
    },
  })

  if (res.status !== 200) {
    throw new Error("book not found")
  }

  const book = await res.json()

  return book
}

export const ensureBookClub = async (rawBook: Book, token?: string): Promise<void> => {
  const authHeaders: {[key: string]: string} = {}
  if (token) {
      authHeaders['token'] = token!
  }

  const res = await fetch(`${config.api.urlV1}/club/by_book/`, {
    method: "POST",
    headers: {
      "Content-type": "application/json",
      ...authHeaders,
    },
    body: JSON.stringify(rawBook)
  })

  if (res.status !== 200) {
    throw new Error("can't create book clubs")
  }

  const club = await res.json()

  return club
}